import { useSnackbar } from "notistack";
import { useState } from "react";
import { API_ENDPOINT } from "../../../data/network/services/ApiEndPoint";
import CustomUploadField from "../../components/CustomUploadField";
import RowButton from "../../components/RowButton";
import { SUCCESS } from "../../resources/constantsManager";
import Sla from "../../../assets/slaaggrement.docx";
import { saveAs } from "file-saver";

const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj).length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};
const formDataPush = (data) => {
  const formdata = new FormData();
  Object.keys(data).map((val, i) => {
    formdata.append(val, data[val]);
  });

  return formdata;
};
function ClientFileUploads({
  onClickNext,
  onClickBack,
  clientData,
  onSuccess,
}) {
  const [uploadSignedSla, setUploadSignedSla] = useState("");
  const [uploadPan, setUploadPan] = useState("");
  const [uploadGstCerts, setUploadGstCerts] = useState("");
  const [uploadIncorporationCert, setUploadIncorporationCert] = useState("");
  const [uploadNdaCertificates, setUploadNDACertificates] = useState("");
  const [uploadCancelledCheque, setUploadCancelledCheque] = useState("");
  const [uploadKycSignAuth, setUploadKycSignAuth] = useState("");
  const [uploadMemoOfAssocation, setMemoOfAssocation] = useState("");
  const [uploadarticleOfAssocation, setUploadArticleOfAssocation] =
    useState("");
  const [uploadMerchantApprovalForm, setUploadMerchantApprovalForm] =
    useState("");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px",
  };

  const { enqueueSnackbar } = useSnackbar();

  const onClickAddClient = (data) => {
    setLoading(true);

    const formdata = formDataPush({ ...clientData, ...data });
    fetch(API_ENDPOINT.basePath + "client/client/onboard", {
      body: formdata,
      headers: {},
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === SUCCESS) {
          // enqueueSnackbar(response.message, {
          //   variant: "success",
          // });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (
  //     reduxData?.uploadSignedSla &&
  //     reduxData?.uploadPan &&
  //     reduxData?.uploadGstCerts &&
  //     reduxData?.uploadIncorporationCert &&
  //     reduxData?.uploadNdaCertificates &&
  //     reduxData?.uploadCancelledCheque &&
  //     reduxData?.uploadKycSignAuth &&
  //     reduxData?.uploadMemoOfAssocation &&
  //     reduxData?.uploadarticleOfAssocation &&
  //     reduxData?.uploadMerchantApprovalForm
  //   ) {
  //     setUploadSignedSla(reduxData?.uploadSignedSla);
  //     setUploadPan(reduxData?.uploadPan);
  //     setUploadGstCerts(reduxData?.uploadGstCerts);
  //     setUploadIncorporationCert(reduxData?.uploadIncorporationCert);
  //     setUploadNDACertificates(reduxData?.uploadNdaCertificates);

  //     setUploadCancelledCheque(reduxData?.uploadCancelledCheque);
  //     setUploadKycSignAuth(reduxData?.uploadKycSignAuth);
  //     setMemoOfAssocation(reduxData?.uploadMemoOfAssocation);
  //     setUploadArticleOfAssocation(reduxData?.uploadarticleOfAssocation);
  //     setUploadMerchantApprovalForm(reduxData?.uploadMerchantApprovalForm);
  //   }
  // }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxHeight: 650,
        overflow: "auto",
      }}
    >
      <p
        style={{
          fontSize: 10,
          color: "grey",
          margin: "10px 0px",
          padding: 0,
          margin: 0,
        }}
      >
        Maximum upload file size 2MB.
      </p>

      <p
        style={{
          fontSize: 10,
          color: "grey",
          margin: "10px 0px",
          marginTop: 3,
        }}
      >
        Please upload files only with following extensions [png, jpg, img,
        image, jpeg, pdf].
      </p>
      {/* saveAs(res, "client.csv"); */}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <p
          onClick={() => saveAs(Sla, "Sla.docx")}
          style={{
            fontSize: 13,
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: "600",
          }}
        >
          Download Agreement
        </p>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          maxHeight: 650,
          overflow: "auto",
        }}
        className="hide-scroll-bar"
      >
        <div>
          <p style={textStyle}>Upload Signed SLA</p>
          <CustomUploadField
            onChange={(data) => setUploadSignedSla(data)}
            onClickRemove={() => {
              setUploadSignedSla("");
            }}
            value={uploadSignedSla}
          />
        </div>
        <div>
          <p style={textStyle}>Upload PAN card</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadPan(data)}
            onClickRemove={() => {
              setUploadPan("");
            }}
          />
        </div>
        <div>
          <p style={textStyle}>Upload GST certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadGstCerts(data)}
            onClickRemove={() => {
              setUploadGstCerts("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Incorporation certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadIncorporationCert(data)}
            onClickRemove={() => {
              setUploadIncorporationCert("");
            }}
          />
        </div>

        <div style={{}}>
          <p style={textStyle}>Upload NDA certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadNDACertificates(data)}
            onClickRemove={() => {
              setUploadNDACertificates("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload cancelled Cheque</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadCancelledCheque(data)}
            onClickRemove={() => {
              setUploadCancelledCheque("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload KYC of the signing authority</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadKycSignAuth(data)}
            onClickRemove={() => {
              setUploadKycSignAuth("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Memorandum of Association</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setMemoOfAssocation(data)}
            onClickRemove={() => {
              setMemoOfAssocation("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Article of Association</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadArticleOfAssocation(data)}
            onClickRemove={() => {
              setUploadArticleOfAssocation("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Merchant Approval Form</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadMerchantApprovalForm(data)}
            onClickRemove={() => {
              setUploadMerchantApprovalForm("");
            }}
          />
        </div>

        <div style={{}}>
          <p style={textStyle}>Commercials Details</p>
          <div
            style={{
              backgroundColor: "#F3F3F3",
              height: 50,
              width: "100%",
              boxShadow: "none",
              outline: "none",
              paddingLeft: 10,
              borderRadius: 5,
              boxSizing: "border-box",
              alignItems: "center",
              display: "flex",
            }}
          >
            {/* <input
              type="checkbox"
              style={{}}
              value={checked}
              onChange={(e) => setChecked(!checked)}
              defaultChecked={checked}
              checked={checked}
            /> */}
            <p style={{ color: "black", fontSize: "14px" }}>
              ₹ 3/- per transaction
            </p>
          </div>
        </div>

        <div
          style={{
            height: 50,
            width: "100%",
            boxShadow: "none",
            outline: "none",
            paddingLeft: 10,
            borderRadius: 5,
            boxSizing: "border-box",
            alignItems: "center",
            display: "flex",
          }}
        >
          <input
            type="checkbox"
            style={{}}
            value={checked}
            onChange={(e) => setChecked(!checked)}
            defaultChecked={checked}
            checked={checked}
          />
          <p style={{ color: "black", fontSize: "14px", marginLeft: 10 }}>
            I accepted the commercials and uploading the documents
          </p>
        </div>
      </div>

      <RowButton
        loading={loading}
        onClickBack={onClickBack}
        onClickNext={() => {
          if (
            checkObjHasAllValue({
              uploadSignedSla,
              uploadPan,
              uploadGstCerts,
              uploadIncorporationCert,
              uploadNdaCertificates,
              uploadCancelledCheque,
              uploadKycSignAuth,
              uploadMemoOfAssocation,
              uploadMerchantApprovalForm,
              uploadarticleOfAssocation,
              checked,
            })
          ) {
            if (!checked) {
              enqueueSnackbar("Please accept the terms", {
                variant: "error",
              });

              return;
            }
            onClickAddClient({
              uploadSignedSlaUrl: uploadSignedSla,
              panCardUrl: uploadPan,
              gstCertificateUrl: uploadGstCerts,
              incorporationCertificateUrl: uploadIncorporationCert,
              ndaCertificateUrl: uploadNdaCertificates,
              cancelledChequeUrl: uploadCancelledCheque,
              kycSigningAuthorityUrl: uploadKycSignAuth,
              memorandumOfAssociationUrl: uploadMemoOfAssocation,
              articleOfAssociationUrl: uploadarticleOfAssocation,
              merchantApprovalFormUrl: uploadMerchantApprovalForm,
              checked,
            });
          } else {
            enqueueSnackbar("Please upload all the files", {
              variant: "error",
            });
          }
        }}
        buttonname2="Submit"
      />
    </div>
  );
}

export default ClientFileUploads;
